<template>
  <div class="plan-hub-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "plan-management-hub",
  mounted() {
    document.documentElement.classList.add("pm-scroll-lock");
  },
  beforeUnmount() {
    document.documentElement.classList.remove("pm-scroll-lock");
  },
};
</script>

<style scoped>
.plan-hub-page {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
